/*
  MOVTECH: a pénztár gomb átirányítása a saját pénztár oldalra.

  A kosár „Pénztár" gombja nem közvetlenül a Shopify fizetőoldalra visz, hanem
  előbb a saját oldalunkra (/cart?view=penztar), ahol a vevő megadja a régiót és
  az átvételi módot, csomagpontnál a konkrét pontot is. Onnan megy tovább a
  natív Shopify checkoutra.

  Miért JS és nem átírt gomb: a pénztár gomb három helyen van, két nagy
  section-fájlban (cart-drawer, main-cart-items). Így egyetlen fájl felel a
  viselkedésért, és ha ez a szkript bármiért nem töltődik be, a gomb a gyári
  módon viselkedik: a vevő a Shopify checkoutra jut, tehát a vásárlás NEM áll
  meg, csak a csomagpont-választás marad ki. Ez szándékos: a rendelési út nem
  bukhat el egy szkripten.

  ⚠ A gyorsfizetés gombokra (Shop Pay, Google Pay, Apple Pay) ez nem vonatkozik:
  azok a Shopify saját iframe-jében futnak, kívülről nem foghatók el, és egyenesen
  a fizetőoldalra visznek, ahol csomagpont nem választható.
  Ezért 2026-08-26 óta a kosár oldalon ki vannak kapcsolva
  (sections/main-cart-items.liquid, a content_for_additional_checkout_buttons blokk
  kommentbe téve). Mérve ugyanekkor: a kosár-drawerben és a termékoldalon nincs
  ilyen gomb, tehát a saját pénztár nem kerülhető meg. Ha valaha visszakapcsolnánk
  a termékoldali „Vásárlás most" gombot, az ismét megkerülné.
*/
(function () {
  "use strict";

  var CEL = "cart?view=penztar";

  var gyoker =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  // Magán a pénztár oldalon nincs dolgunk: onnan a saját gombja visz tovább.
  if (window.location.search.indexOf("view=penztar") !== -1) return;

  function penztarGomb(elem) {
    if (!elem || !elem.closest) return null;
    return elem.closest('[name="checkout"]');
  }

  function atiranyitas() {
    window.location.href = gyoker + CEL;
  }

  // Capture fázis: a téma saját kezelője (loading-button, űrlap-beküldés) előtt
  // kell elkapnunk a kattintást, különben elviszi a gyári checkoutra.
  document.addEventListener(
    "click",
    function (esemeny) {
      if (!penztarGomb(esemeny.target)) return;
      esemeny.preventDefault();
      esemeny.stopPropagation();
      atiranyitas();
    },
    true
  );

  // Billentyűzetes beküldés (Enter a kosár űrlapján) ugyanide tartozik.
  document.addEventListener(
    "submit",
    function (esemeny) {
      var kuldo = esemeny.submitter;
      if (!penztarGomb(kuldo)) return;
      esemeny.preventDefault();
      esemeny.stopPropagation();
      atiranyitas();
    },
    true
  );
})();
